import { render } from "./CashRegister.vue?vue&type=template&id=48440298"
import script from "./CashRegister.vue?vue&type=script&lang=js"
export * from "./CashRegister.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/JBN/mi-stock-jbn-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__